import { t } from "@lingui/core/macro";

import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

export const getEventNavigationLabel = (eventPluralOverride?: string | null) =>
  getNounOverride(eventPluralOverride, t`Events`);
